class ThreeSixtyProductGallery extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback();
    this.setupThreeSixtyGallery();
  }

  setupThreeSixtyGallery () {
    var images = [];
    var imageElements = this.externalEls.imageSources.elements;
    imageElements.forEach(function (el) {
      images.push(el.textContent);
    });

    var threesixty = new ThreeSixty(this.els.gallery.element, {
      image: images,
      width: 500,
      height: 'auto',
      speed: 100,
      keys: true,         // Rotate image on arrow keys. Default: true
      draggable: true,    // Rotate image by dragging. Default: true
      swipeable: true,    // Rotate image by swiping on mobile screens. Default: true
      dragTolerance: 10,  // Rotation speed when dragging. Default: 10
      swipeTolerance: 10, // Rotation speed when swiping. Default: 10
      swipeTarget: this.externalEls.wrapper.element, // Element which will listen for drag/swipe events. Default: Image container
    });
  }
}

if (!customElements.get('threesixty-product-gallery')) {
  customElements.define('threesixty-product-gallery', ThreeSixtyProductGallery)
}